import React from 'react';

export function TableViewCardSkeleton() {

  return (
    <article
      id="table-view-card-skeleton"
      className="shadow-sm border p-3 bg-white flex flex-col gap-3 w-full animate-pulse"
    >
      {/* Header */}
      <div className="flex justify-between gap-2 pr-2 pb-2 border-b-2 border-gray-200">
        <div className="h-5 w-2/3 bg-gray-200 rounded" />
        <div className="flex gap-3">
          <div className="h-4 w-10 bg-gray-200 rounded" />
          <div className="h-4 w-10 bg-gray-200 rounded" />
          <div className="h-4 w-14 bg-gray-200 rounded" />
        </div>
      </div>

      <div id="tvc-body-skeleton" className="max-h-[381px] h-full flex w-full">
        {/* Left side */}
        <div className="flex flex-col items-center max-w-[400px] flex-1 pr-0 sm:pr-6 gap-4">
          <div className="w-[400px] h-[268px] bg-gray-200 rounded" />

          {/* Generalized stats block */}
          <div className="grid grid-cols-3 gap-4 w-full">
            {[ ...Array(3) ].map((_, i) => (
              <div key={i} className="flex flex-col items-center gap-2">
                <div className="h-3 w-16 bg-gray-200 rounded" />
                <div className="h-5 w-20 bg-gray-300 rounded" />
              </div>
            ))}
          </div>
        </div>

        {/* Right side */}
        <div className="flex flex-1 flex-col ml-4 p-3 gap-4">
          {/* CTA Row */}
          <div className="flex justify-between mb-4 w-full">
            <div className="h-8 w-24 bg-gray-200 rounded" />
            <div className="h-8 w-24 bg-gray-200 rounded" />
          </div>

          {/* Specs list */}
          <div className="flex flex-col gap-3">
            {[ ...Array(5) ].map((_, i) => (
              <div key={i} className="flex justify-between border-b-2 border-gray-200 px-4 py-2">
                <div className="h-3 w-28 bg-gray-200 rounded" />
                <div className="h-3 w-16 bg-gray-300 rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}
